import { LoadingCart } from '.';

type Props = {
  bgTransparent?: boolean;
};

export const LoadingCartFullPage = ({ bgTransparent = false }: Props) => {
  return (
    <div
      className={`flex h-screen w-full items-start justify-center ${
        bgTransparent ? 'bg-transparent' : 'bg-primary-dark'
      }`}
    >
      <div className='flex w-40 flex-col items-center justify-center gap-2'>
        <LoadingCart customBgColor={bgTransparent ? 'bg-transparent' : ''} />
      </div>
    </div>
  );
};
